<ds-promo-badge iconSrc="/assets/icons/holiday_village.svg" iconAlt="seat" label="Hotel stay" />
